import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

interface IProps {
  icon?: JSX.Element;
  title: string;
  selected?: boolean;
  onClick?: () => void;
}

type TabWrapperProps = { children?: ReactNode; onClick?: () => void };

export const TabWrapper = styled.div<TabWrapperProps>`
  border-bottom: ${({ theme }) => `1px solid ${theme.palette.neutral.lightest}`};

  &:hover {
    cursor: pointer;
  }
`;

type TitleProps = { selected?: boolean; children?: ReactNode };

export const Title = styled.a<TitleProps>`
  background-color: ${({ theme }) => theme.palette.backgrounds.main};
  display: block;
  margin: 10px 0;
  padding: 18px 30px;
  position: relative;
  transition: all 0.3s linear;

  ${({ selected }) =>
    selected &&
    css`
      background-color: ${({ theme }) => theme.palette.backgrounds.tab};
    `}

  @media (max-width: 991px) {
    margin: 5px 0;
    padding: 13px 15px;
  }
`;

const ListItem = ({ title, selected, onClick }: IProps) => {
  return (
    <TabWrapper onClick={onClick}>
      <Title selected={selected}>{title}</Title>
    </TabWrapper>
  );
};

export default ListItem;
